/* unplugin-vue-components disabled */import { render } from "./TopTitle.vue?vue&type=template&id=4568e7fe&scoped=true"
import script from "./TopTitle.vue?vue&type=script&lang=js"
export * from "./TopTitle.vue?vue&type=script&lang=js"

import "./TopTitle.vue?vue&type=style&index=0&id=4568e7fe&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgy-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4568e7fe"]])

export default __exports__